<template>
  <Container>
    <div class="wizard__sms">
      <v-layout align-center justify-center row fill-height>
        <v-flex md10>
          <header class="text-xs-center">
            <h1 class="wizard__sms__title">
              <span>{{ $t(`${namespace}.share`) }}</span> {{ $t(`${namespace}.news`) }}
            </h1>
            <p class="wizard__sms__subtitle" v-html="$t(`${namespace}.subtitle`).replace('[COUNT]', employeesCount)" />
          </header>

          <div class="wizard__sms__content">
            <iframe src="https://www.youtube.com/embed/hE4zWv8O-Hc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>

          <footer class="wizard__sms__footer">
            <v-btn
              v-if="claims.employee['ROLE_EMPLOYEE_WIZARD_PHONE_NUMBERS']"
              :disabled="isFetching"
              :loading="isFetching"
              color="warning--gradient"
              class="mx-0"
              round
              depressed
              large
              @click="handleSendSms"
            >
              <span v-html="$t(`${namespace}.shareWithMyEmployees`)" />
            </v-btn>

            <div class="wizard__escape__container">
              <a
                :title="$t('Views.Wizard.welcome.skipTutorial')"
                class="wizard__escape"
                @click="openAccessPlatformDialog"
              >
                {{ $t('Views.Wizard.welcome.skipTutorial') }}
              </a>
            </div>
          </footer>
        </v-flex>
      </v-layout>
    </div>
  </Container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Container from 'components/wizard/Container'

export default {
  name: 'Sms',
  props: {
    employeesCount: {
      type: Number,
      default: 0
    },
    employeesList: {
      type: Array
    }
  },
  components: {
    Container
  },
  computed: {
    ...mapState({
      globalCompany: (state) => state.company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.Wizard.sms',
      isFetching: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    handleSetStep () {
      this.$emit('handleSetStep', {
        step: 'success'
      })
    },

    openAccessPlatformDialog () {
      this.$emit('openAccessPlatformDialog')
    },

    async handleSendSms () {
      this.$ga.event('botao', 'clicou', 'compartilhar_video')

      this.isFetching = true

      try {
        await this.$apiService.sendSms({
          companyId: this.globalCompany.id,
          phoneNumbers: this.employeesList
        })
        this.handleSetStep()
      } catch (err) {
        console.log('ERROR', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorMessage`)
        })
      }

      this.isFetching = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard__sms {
  padding: 0 15px;
}

.wizard__sms__title,
.wizard__sms__subtitle {
  font-family: 'Montserrat', sans-serif;
}

.wizard__sms__title {
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
  margin-bottom: 10px;

  @media (min-width: 992px) {
    font-size: 36px;
  }

  span {
    color: $accent;
  }
}

.wizard__sms__subtitle {
  color: $gray-6;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 40px;

  strong {
    color: $gray-8 !important;
    font-weight: 600;
  }
}

.wizard__sms__content {
  display: block;
  margin: 0 auto;
  max-width: 488px;

  iframe {
    min-height: 274px;
    width: 100%;
  }
}

.wizard__sms__footer {
  text-align: center;
  padding-top: 25px;
}
</style>
